// ===============================================================
// AGE POPUP
// ===============================================================
const AgeComponent = {
  root: document.querySelector('.age-verification-overlay'),

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  },

  getCookie(name) {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='))
      ?.split('=')[1];
  },

  bindEvents() {
    const yesBtn = this.root.querySelector('.age-verification-btn-yes');

    if (!yesBtn) return;

    yesBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.setCookie('age-check', 'true', 7);
      this.root.style.display = 'none';
    });
  },

  init() {
    if (!this.root) return;

    const consent = this.getCookie('age-check') === 'true';

    if (consent) {
      this.root.style.display = 'none';
      return;
    }

    this.root.style.display = 'block';
    this.bindEvents();
  }
};
export default AgeComponent;
